import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { EmailCampaignComponent } from './email-campaign.component';
import { EmailCampaignConnectComponent } from "./email-campaign-connect/email-campaign-connect.component";
import { EmailCampaignDashboardComponent } from './email-campaign-dashboard/email-campaign-dashboard.component';
import { M } from '@angular/cdk/keycodes';
import { EmailCampaignCreateCampaignComponent } from './email-campaign-create-campaign/email-campaign-create-campaign.component';
import { CreateCampaignZeroComponent } from './create-campaign-zero/create-campaign-zero.component';
import { CampaignListingComponent } from './campaign-listing/campaign-listing.component';
const routes: Routes = [
    {
        path: 'email-campaign',
        component: EmailCampaignComponent,
        children: [
            {
                path: '',
                redirectTo: 'connect',
                pathMatch: 'full'
            },
            {
                path: 'connect',
                component: EmailCampaignConnectComponent
            },
            {
                path:'dashboard',
                redirectTo: 'dashboard',
                pathMatch: 'full'
            },
            {
                path: 'dashboard',
                component: EmailCampaignDashboardComponent
            },
            {
                path: 'campaign-listing',
                component: EmailCampaignCreateCampaignComponent
            },
            {
                path: 'create-campaign-stages/:campaign_id',
                component: CreateCampaignZeroComponent
            },
            {
                path: 'target-listing/:campaign_id',
                component: CampaignListingComponent
            },
            {
                path: 'target-listing/add-candidate/:campaign_id',
                component: CampaignListingComponent
            }
        ]
    }
];

@NgModule({
    imports: [
        RouterModule.forChild(routes)
    ],
    exports: [
        RouterModule
    ]
})
export class EmailCampaignRoutingModule { }